<!-- src/views/HomeView.vue -->
<template>
  <div class="home-view" :style="bgStyle">

    <main class="home-main container">
      <section class="hero card">
        <div class="hero-left">
          <h1 class="hero-title">
            <span class="highlight">Каталог данных</span> компьютерной томографии
          </h1>
          <p class="hero-desc">
            Поможем легко и быстро <span class="highlight">найти, изучить и проанализировать томографические данные</span> из различных областей исследований.
          </p>
          <h1 class="hero-title">
            Количество образцов на портале: <span class="highlight">2584</span>
          </h1>
        </div>
        <div class="hero-right"></div>
      </section>

      <section class="categories" style="margin-top:24px;">
        <CategoryCard
          v-for="cat in categories"
          :key="cat.id"
          :title="cat.title"
          :img="cat.img"
          :blocks="cat.blocks"
          :primary-route="cat.route"
          :primary-label="cat.routeLabel"
          :show-database="false"
        />
      </section>
    </main>

    <!-- DEMO NOTICE MODAL (teleported to body so stacking/context issues avoided) -->
    <teleport to="body">
      <transition name="fade">
        <div
          v-if="showDemoModal"
          class="demo-modal"
          role="dialog"
          aria-modal="true"
          aria-labelledby="demo-title"
          @keydown.esc="closeDemo"
        >
          <div class="demo-modal-inner" @click.self="closeDemo">
            <div class="demo-modal-box" role="document">
              <h2 id="demo-title" class="demo-title">Внимание — демоверсия</h2>
              <p class="demo-text">
                Вы находитесь на демоверсии сайта. Расширенная версия с возможностью подписки и доступом
                к полному каталогу данных находится в разработке.
              </p>
              <p class="demo-text">
                Вы можете написать нам на почту
                <a href="mailto:tomowebsolutions@yandex.ru">tomowebsolutions@yandex.ru</a>
                и мы добавим Вас в рассылку с анонсом запуска полной версии сайта.
              </p>

              <div class="demo-actions">
                <button type="button" class="btn btn-primary" @click="closeDemo" aria-label="ОК">ОК</button>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </teleport>

  </div>
</template>

<script>
import CategoryCard from '@/components/home/CategoryCard.vue'
import planetImg from '@/assets/planet.png'
import lifeImg from '@/assets/life.png'
import historyImg from '@/assets/history.png'
import materialsImg from '@/assets/materials.png'
import bgImage from '@/assets/homepage-bg-image_small.png'

export default {
  name: 'HomeView',
  components: { CategoryCard },
  data() {
    return {
      bgImage,
      categories: [
        {
          id: 1,
          title: 'Науки о Земле',
          img: planetImg,
          blocks: [
            { title: 'Керн месторождений УВ и ТПИ', text: 'Неразрушающий анализ строения скважинных кернов, контроль качества образцов, оценки пористости, плотности, трещиноватости и моделирования различных свойств.' },
            { title: 'Почвы', text: 'Рентгеновская томография в почвоведении применяется для изучения структуры почв. Этот метод позволяет визуализировать их внутреннее строение и моделировать процессы фильтрации.' },
            { title: 'Донные грунты', text: 'Методы рентгеновской томографии позволяют исследовать внутреннее строение, текстурные и структурные особенности неконсолидированных отложений дна озер и морей.' },
            { title: 'Палеонтологические образцы', text: 'Реконструирование анатомии древних животных, исследование внутренней полости и следов тканей, анализ процессов окаменения и адаптации к окружающей среде.' }
          ],
          route: { name: 'map' },
          routeLabel: 'Исследовать на карте'
        },
        {
          id: 2,
          title: 'Науки о Жизни',
          img: lifeImg,
          blocks: [
            { title:'Ботаника', text:'Изучение внутренней структуры растений, включая распределение тканей, рост корней и гидратацию стеблей. Это помогает исследовать физиологические процессы и адаптацию растений к окружающей среде.' },
            { title:'Зоология', text:'Внутреннее строение скелета, раковин и тканей животных для анализа их морфологии, эволюции и особенностей развития.' },
            { title:'Физиология', text:'Рентгеновская томография применяется для визуализации и анализа функций органов и тканей в живых организмах.' },
            { title:'Экология', text:'Исследование взаимодействия организмов и их среды, например, анализа структуры почвы, корневых систем растений или микроорганизмов внутри экосистем.' }
          ],
          route: { name: 'life' },
          routeLabel: 'Перейти в раздел'
        },
        {
          id: 3,
          title: 'Общественные науки',
          img: historyImg,
          blocks: [
            { title:'Археология', text:'Исследуются внутренние структуры керамики, металлических изделий и инструментов, выявляются скрытые надписи и дефекты.' },
            { title:'Антропология', text:'Технология позволяет исследовать особенности погребальных ритуалов и идентифицировать следы взаимодействия древних людей с окружающей средой.' },
            { title:'Геммология', text:'Геммология изучает драгоценные камни и их свойства: оценка структуры, включений и обработки, что помогает аутентифицировать и исследовать украшения.' },
            { title:'История искусства', text:'Метод используется для обнаружения скрытых элементов и анализа материалов, применяемых художниками и ремесленниками.' }
          ],
          route: { name: 'social' },
          routeLabel: 'Перейти в раздел'
        },
        {
          id: 4,
          title: 'Материаловедение',
          img: materialsImg,
          blocks: [
            { title:'Контроль качества', text:'Метод позволяет выявлять внутренние дефекты, такие как трещины, поры или инородные включения, а также анализировать равномерность структуры и плотность.' },
            { title:'Реверс - инжиниринг', text:'Восстановление геометрии внутренней структуры объектов, недоступных традиционным измерительным методам.' },
            { title:'Композиционные материалы', text:'Изучение внутренней структуры многослойных и волокнистых композитов, применяемых в разных отраслях.' },
            { title:'Металлургия', text:'Исследование распределения фаз, пористости и зернистой структуры помогает совершенствовать технологии производства.' }
          ],
          route: { name: 'materials' },
          routeLabel: 'Перейти в раздел'
        }
      ],

      // modal control
      showDemoModal: false
    }
  },
  computed: {
    bgStyle() { return { backgroundImage: `url(${this.bgImage})` } }
  },
    mounted() {
    // Показать модал при первом входе в сессии, если пользователь ещё не закрывал уведомление в этой сессии.
    try {
      const dismissed = sessionStorage.getItem('demoNoticeDismissed')
      // если ключа нет или он не равен "1" — показываем модал
      if (dismissed !== '1') {
        // малый таймаут, чтобы дать время отрисовать страницу и не заслонять всё сразу
        setTimeout(() => { this.showDemoModal = true }, 200)
      }
    } catch (e) {
      // если sessionStorage недоступен — просто показать модал
      setTimeout(() => { this.showDemoModal = true }, 200)
    }
  },

  methods: {
    closeDemo() {
      // Закрываем модал и сохраняем маркер в sessionStorage, чтобы не показывать снова в текущей сессии
      this.showDemoModal = false
      try {
        sessionStorage.setItem('demoNoticeDismissed', '1')
      } catch (e) {
        // ignore
      }
    }
  }
}
</script>

<style scoped>
.container { max-width:1500px; margin:0 auto; padding:24px; }
.hero { display:flex; gap:20px; align-items:center; justify-content:space-between; padding:32px; border-radius:20px; background: transparent; }
.hero-title { font-size:48px; margin:0 0 32px; color:var(--hp-font-color,#F0F0F0); font-weight:700; }
.hero-desc { font-size:30px; color:var(--hp-font-color,#F0F0F0); opacity:0.9; margin:0; max-width: 900px; }

.home-view {
  min-height:100vh;
  background-color: var(--bg, #222222); /* базовый цвет */
  color: var(--hp-font-color, #F0F0F0);

  /* параметры фонового изображения (второй слой) */
  background-repeat: no-repeat;
  background-position: right top;   /* подвинь как нужно: right top / center top / left bottom */
  background-size: cover;         /* 'contain' — изображение поместится; можно заменить на 'cover' */
  /* background-attachment: fixed;   если хочешь фиксированный фон относительно вьюпорта */
}

.categories { display: grid; grid-template-columns: 1fr; gap: 24px; }

.highlight { color: #75E4F5; font-weight: bold; }

@media (max-width: 900px){ .hero { flex-direction:column } .home-view { background-position: center top; background-size: cover } }

/* ---------------- Demo modal styles ---------------- */
/* Подобные стили уже используются в проекте — логика и внешний вид совместимы */
.fade-enter-active, .fade-leave-active { transition: opacity .18s ease; }
.fade-enter-from, .fade-leave-to { opacity: 0; }

.demo-modal {
  position: fixed;
  inset: 0;
  display:flex;
  align-items:center;
  justify-content:center;
  z-index: 2147484000;
  background: rgba(0,0,0,0.48);
  padding: 24px;
  box-sizing: border-box;
}

/* внутренний контейнер (клик по нему не закрывает, клик по overlay — закрывает) */
.demo-modal-inner {
  width:100%;
  max-width:720px;
  display:flex;
  align-items:center;
  justify-content:center;
  padding: 12px;
  box-sizing:border-box;
}

/* собственно коробка с текстом */
.demo-modal-box {
  width:100%;
  background: #fff;
  color: #222;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 12px 40px rgba(0,0,0,0.25);
  max-height: 80vh;
  overflow:auto;
}

/* заголовок и текст */
.demo-title { margin:0 0 8px 0; font-size:18px; font-weight:700; color:#111 }
.demo-text { margin: 8px 0; color:#333; line-height:1.5; }

/* actions row */
.demo-actions { display:flex; justify-content:flex-end; margin-top: 14px; gap:8px; }
.demo-actions .btn { cursor:pointer; }

/* используем существующие классы .btn и .btn-primary если они есть; иначе обеспечиваем базовую видимость */
.btn { padding:8px 12px; border-radius:8px; text-decoration:none; font-weight:700; background:transparent; color:inherit; border:1px solid rgba(0,0,0,0.06); }
.btn-primary { background:var(--hp-button-color,#75E4F5); color:#022; border: none; }

/* адаптив */
@media (max-width:520px) {
  .demo-modal-box { padding: 14px; }
  .demo-title { font-size:16px }
}
</style>
